import Queue from "nq-js";

class SaveFileUseCase {
  execute(blob, session) {
    return new Queue.File().save(blob, session);
  }
}

export default SaveFileUseCase;
